export const advsMapping = {
    'season-ranking-gallery': {
        'data-revivezoneid': '19804',
        'data-reviveid': '6609ba8ff88606794e22ff360400bcea',
    }
}